<template>
    <div>
        <page-title :title="$t('registers.employees.organogramTitle')">
        </page-title>
        <div>
            <Organogram> </Organogram>
        </div>
        <div class="m-2">
            <div class="alert alert-info" role="alert">
                <ul>
                    <li>Press Ctrl + left mouse button to move the component.</li>
                    <li>Point an element with the mouse pointer and use the mouse scroller button to resize the component.</li>
                </ul>
            </div>
            
        </div>
    </div>
</template>

<script>
    import Organogram from '../../../components/registers/nijEmployee/Organogram';
    import PageTitle from '../../../components/common/PageTitle';


    export default {
        components: {
            Organogram,
            PageTitle
        },
        data() {
            return {
                componentName: "EmployeesOrthogram",
            }
        },
        methods: {
           
        },
        mounted: function () {
            
        },
        computed: {
            
        },
        created: function () {
           
        },

    }
</script>

<style scoped>

</style>
